// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.style_container_box_radio__GbZ0C:checked, .style_pagination__-pnY- button, .style_pagination__-pnY- div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_interface_heading_row__YDt67 {
  display: flex;
  align-items: center;
}

.style_interface_noResults__uF3o0 {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.style_container__hMoe8 {
  display: flex;
  justify-content: space-between;
}

.style_container_box_details__SyGIC, .style_interface__sV\\+t1 {
  display: flex;
  flex-direction: column;
}

a {
  text-decoration: none;
}

.style_link__ZP4xt {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__ZP4xt:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__Idx4A {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__9A5MU {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__bQ45a, .style_interface_heading__-6UwV, .style_interface_footer__auf2x {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__HAZGJ {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__5aj0W {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__5aj0W {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__ipTg8 {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__ipTg8 {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__-OIIh {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__-OIIh {
    line-height: 1.5rem;
  }
}

.style_breadcumb__QNpKd {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.style_breadcumb__QNpKd a,
.style_breadcumb__QNpKd span {
  padding: 3px 5px;
}
.style_breadcumb__QNpKd a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.style_breadcumb__QNpKd a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.style_breadcumb__QNpKd .style_divider__P-E1L {
  color: var(--color-gray-400);
}

.style_badge__yYZwh {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badge__yYZwh.style_xs__DkoRS {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badge__yYZwh.style_sm__B8cj4 {
  padding: 4px 7px;
}
.style_badge__yYZwh.style_primary__YImac {
  background: var(--color-primary-500);
}
.style_badge__yYZwh.style_primary__YImac, .style_badge__yYZwh.style_pm__er\\+wE {
  background: var(--color-primary-500);
}
.style_badge__yYZwh.style_sd__QHKka {
  background-color: var(--color-secundary-500);
}
.style_badge__yYZwh.style_Likely__g7JW0 {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.style_badge__yYZwh.style_Unvalidated__nwQtF {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.style_badge__yYZwh.style_Verified__YsV-R, .style_badge__yYZwh.style_green__\\+An0w {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badge__yYZwh.style_off__swAqn {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_badgeTable__aWDsd {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badgeTable__aWDsd.style_xs__DkoRS {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badgeTable__aWDsd.style_sm__B8cj4 {
  padding: 4px 7px;
}
.style_badgeTable__aWDsd.style_primary__YImac, .style_badgeTable__aWDsd.style_pm__er\\+wE {
  background: var(--color-primary-500);
}
.style_badgeTable__aWDsd.style_sd__QHKka {
  background-color: var(--color-secundary-500);
}
.style_badgeTable__aWDsd.style_Likely__g7JW0 {
  background: #413e1a;
  color: #e6f979;
}
.style_badgeTable__aWDsd.style_Verified__YsV-R, .style_badgeTable__aWDsd.style_green__\\+An0w {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badgeTable__aWDsd.style_off__swAqn {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_table__Qfdlv {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.style_table__Qfdlv.style_style-1__Fy5p5 td,
.style_table__Qfdlv.style_style-1__Fy5p5 th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.style_table__Qfdlv.style_style-1__Fy5p5 th,
.style_table__Qfdlv.style_style-1__Fy5p5 td.style_label__tcCt- {
  color: var(--color-white-500);
}
.style_table__Qfdlv.style_style-1__Fy5p5 th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.style_table__Qfdlv.style_style-1__Fy5p5 tr.style_noBorder__DVv17 td {
  border-bottom: none;
}
.style_table__Qfdlv.style_style-1__Fy5p5 tr td {
  color: var(--color-white-500);
}

.style_pagination__-pnY- {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.style_pagination__-pnY- button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__-pnY- button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__-pnY- button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_pagination__-pnY- button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__-pnY- button.style_disabled__xdb2v, .style_pagination__-pnY- button.style_active__Z4743, .style_pagination__-pnY- button.style_info__2waEW {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__-pnY- button.style_disabled__xdb2v {
  color: var(--color-gray-700);
}
.style_pagination__-pnY- div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__-pnY- div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__-pnY- div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.style_pagination__-pnY- div:hover, .style_pagination__-pnY- div.style_active__Z4743 {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .style_pagination__-pnY- div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__-pnY- div.style_disabled__xdb2v, .style_pagination__-pnY- div.style_active__Z4743, .style_pagination__-pnY- div.style_info__2waEW {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__-pnY- div.style_disabled__xdb2v {
  color: var(--color-gray-700);
}
.style_pagination__-pnY- div:last-child, .style_pagination__-pnY- div:first-child {
  padding: 0 10px;
}
.style_pagination__-pnY- div:last-child {
  border-right: none;
}
.style_pagination__-pnY- button:last-child, .style_pagination__-pnY- button:first-child {
  padding: 0 10px;
}
.style_pagination__-pnY- button:last-child {
  border-right: none;
}

.style_interface__sV\\+t1 {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.style_interface_heading__-6UwV {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading__-6UwV {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_heading__-6UwV > div {
    width: 100%;
  }
}
.style_interface_heading_row__YDt67 {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading_row__YDt67 {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_footer__auf2x {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .style_interface_footer__auf2x {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_footer__auf2x > div {
    width: 100%;
  }
}
.style_interface_foot__feYli {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_foot__feYli {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_noResults__uF3o0 {
  gap: 15px;
  padding: 70px 0;
}

.style_container__hMoe8 {
  width: 100%;
  padding: 13px;
  gap: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  text-align: left;
}
.style_container_active__J1jPn {
  background-color: var(--bg-color);
  position: relative;
  border: none;
  z-index: 1;
}
.style_container_active__J1jPn::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 8px;
  padding: 1px;
  background: var(--gradient);
  -webkit-mask: var(--gradient-border) content-box, var(--gradient-border);
  mask-composite: exclude;
  z-index: -1;
}
.style_container_box__-AkNw {
  display: flex;
  gap: 12px;
}
.style_container_box_details__SyGIC {
  color: var(--color-white-500);
}
.style_container_box_details_last4__UYXoY {
  font-size: 14px;
}
.style_container_box_details_exp__-6yU\\+ {
  font-size: 14px;
  margin-top: 5px;
}
.style_container_box_details_default__I54ND {
  font-size: 14px;
  font-weight: 500;
  margin-top: 8px;
  cursor: pointer;
}
.style_container_box_details_default__I54ND:hover {
  text-decoration: underline;
}
.style_container_box_radio__GbZ0C {
  appearance: none;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  background-color: transparent;
  border: 1px solid var(--color-gray-700);
  transition-property: all;
  transition-duration: 350ms;
}
.style_container_box_radio__GbZ0C:hover {
  cursor: pointer;
  border-color: var(--main-color);
}
.style_container_box_radio__GbZ0C:checked {
  background-image: var(--gradient-border);
  position: relative;
}
.style_container_box_radio__GbZ0C:checked::before {
  content: "✓";
  color: #fff;
  font-size: 18px;
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/CardItem/style.module.scss","webpack://./src/assets/scss/_flex.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss","webpack://./src/assets/scss/_colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ADEF;;ACCA;EACE,aAAA;EACA,mBAAA;ADEF;;ACYA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ADTF;;ACuBA;EACE,aAAA;EACA,8BAAA;ADpBF;;ACuBA;EACE,aAAA;EACA,sBAAA;ADpBF;;AEnBA;EACI,qBAAA;AFsBJ;;AEpBA;EACI,eAAA;EACA,cAAA;AFuBJ;AEtBI;EACE,0BAAA;AFwBN;;AEpBA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AFuBJ;;AEpBI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;AFuBR;AErBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;AFuBR;AErBI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;AFuBR;AErBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;AFuBR;AG/DE;EDsCE;IAIQ,eAAA;IACA,mBAAA;EFyBV;AACF;AEvBI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;AFyBR;AGzEE;ED8CE;IAIQ,eAAA;IACA,mBAAA;EF2BV;AACF;AEzBI;EACI,mBAAA;AF2BR;AGlFE;EDsDE;IAGQ,mBAAA;EF6BV;AACF;;AIrFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AJwFF;AIvFE;;EAEE,gBAAA;AJyFJ;AIvFE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AJyFJ;AIxFI;EACE,+BAAA;EACA,uCAAA;AJ0FN;AIvFE;EACE,4BAAA;AJyFJ;;AK7GA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;ALgHF;AK7GE;EACE,gBAAA;EACA,eAAA;AL+GJ;AK7GE;EACE,gBAAA;AL+GJ;AK3GE;EACE,oCAAA;AL6GJ;AK3GE;EAEE,oCAAA;AL4GJ;AK1GE;EACE,4CAAA;AL4GJ;AK1GE;EACE,uCAAA;EACA,mCAAA;AL4GJ;AK1GE;EACE,oCAAA;EACA,gCAAA;AL4GJ;AK1GE;EAEE,4CAAA;EACA,kCAAA;AL2GJ;AKzGE;EACE,6BAAA;EACA,uCAAA;AL2GJ;;AKxGA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AL2GF;AKxGE;EACE,gBAAA;EACA,eAAA;AL0GJ;AKxGE;EACE,gBAAA;AL0GJ;AKtGE;EAEE,oCAAA;ALuGJ;AKrGE;EACE,4CAAA;ALuGJ;AKrGE;EACE,mBAAA;EACA,cAAA;ALuGJ;AKrGE;EAEE,4CAAA;EACA,kCAAA;ALsGJ;AKpGE;EACE,6BAAA;EACA,uCAAA;ALsGJ;;AM9LA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;ANiMF;AM/LI;;EAEE,kBAAA;EACA,mBAAA;ANiMN;AM/LI;;EAEE,6BAAA;ANiMN;AM/LI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;ANiMN;AM9LM;EACE,mBAAA;ANgMR;AM9LM;EACE,6BAAA;ANgMR;;AOpNA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;APsNJ;AOpNI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;APqNR;AOpNQ;EACI,2BAAA;EACA,8BAAA;APsNZ;AOpNQ;EACI,4BAAA;EACA,+BAAA;APsNZ;AGrPE;EIgBE;IAkBQ,eAAA;IACA,eAAA;EPuNV;AACF;AOtNQ;EACI,eAAA;EACA,oBAAA;APwNZ;AOtNQ;EACI,4BAAA;APwNZ;AOrNI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;APsNR;AOrNQ;EACI,2BAAA;EACA,8BAAA;APuNZ;AOrNQ;EACI,4BAAA;EACA,+BAAA;APuNZ;AOrNQ;ECrCJ,eAAA;EACA,qFAAA;AR6PJ;AGvRE;EI6CE;IAqBQ,eAAA;IACA,eAAA;EPyNV;AACF;AOxNQ;EACI,eAAA;EACA,oBAAA;AP0NZ;AOxNQ;EACI,4BAAA;AP0NZ;AOvNI;EACI,eAAA;APyNR;AOvNI;EACI,kBAAA;APyNR;AOvNI;EACI,eAAA;APyNR;AOvNI;EACI,kBAAA;APyNR;;AS3SA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;AT8SF;AS5SE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;AT6SJ;AGrUE;EMeA;IAWI,kBAAA;IACA,uBAAA;ET+SJ;ES9SI;IACE,WAAA;ETgTN;AACF;AS9SI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;AT+SN;AGnVE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ETiTN;AACF;AS9SE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;AT+SJ;AGnWE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ETiTJ;EShTI;IACE,WAAA;ETkTN;AACF;AS/SE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;ATiTJ;AGjXE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ETmTJ;AACF;ASjTE;EAEE,SAAA;EACA,eAAA;ATkTJ;;AA1XA;EACE,WAAA;EACA,aAAA;EAEA,SAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AA4XF;AA1XE;EACE,iCUVO;EVWP,kBAAA;EACA,YAAA;EACA,UAAA;AA4XJ;AA3XI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,2BUXK;EVYL,wEAAA;EAEA,uBAAA;EACA,WAAA;AA6XN;AAzXE;EACE,aAAA;EACA,SAAA;AA2XJ;AA1XI;EAEE,6BAAA;AA2XN;AA1XM;EACE,eAAA;AA4XR;AA1XM;EACE,eAAA;EACA,eAAA;AA4XR;AA1XM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AA4XR;AA3XQ;EAAU,0BAAA;AA8XlB;AA1XI;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,uCAAA;EACA,wBAAA;EACA,0BAAA;AA4XN;AA3XM;EACE,eAAA;EACA,+BU/DK;AV4bb;AA3XM;EACE,wCUvDU;EVwDV,kBAAA;AA6XR;AAzXM;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AA2XR","sourcesContent":["@use \"/src/assets/scss/\" as *;\n\n.container {\n  width: 100%;\n  padding: 13px;\n  @extend %flex-justify-between;\n  gap: 12px;\n  border: 1px solid $border;\n  border-radius: 8px;\n  text-align: left;\n\n  &_active {\n    background-color: $bg-color;\n    position: relative;\n    border: none;\n    z-index: 1;\n    &::before {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      border-radius: 8px;\n      padding: 1px;\n      background: $gradient;\n      -webkit-mask: $gradient-border content-box, $gradient-border;\n      -webkit-mask-composite: xor;\n      mask-composite: exclude;\n      z-index: -1;\n    }\n  }\n\n  &_box {\n    display: flex;\n    gap: 12px;\n    &_details {\n      @extend %flex-column;\n      color: var(--color-white-500);\n      &_last4 {\n        font-size: 14px;\n      }\n      &_exp {\n        font-size: 14px;\n        margin-top: 5px;\n      }\n      &_default {\n        font-size: 14px;\n        font-weight: 500;\n        margin-top: 8px;\n        cursor: pointer;\n        &:hover { text-decoration: underline; }\n      }\n    }\n\n    &_radio {\n      -webkit-appearance: none;\n      appearance: none;\n      width: 28px;\n      height: 28px;\n      border-radius: 100%;\n      background-color: transparent;\n      border: 1px solid var(--color-gray-700);\n      transition-property: all;\n      transition-duration: 350ms;\n      &:hover {\n        cursor: pointer;\n        border-color: $main-color;\n      }\n      &:checked {\n        background-image: $gradient-border;\n        position: relative;\n        @extend %flex-center;\n      }\n\n      &:checked::before {\n        content: \"✓\";\n        color: #fff;\n        font-size: 18px;\n        padding: 5px;\n      }\n    }\n  }\n}\n","%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}","//Global colors\n$main-color: var(--main-color);\n$bg-color: var(--bg-color);\n$dark-bg: var(--dark-bg);\n$body-bg: var(--body-bg);\n$error-color: var(--error-color);\n\n$color-gradient-black-500: var(--color-gradient-black-500);\n$color-gradient-black-200: var(--color-gradient-black-200);\n\n//Gradient\n$gradient: var(--gradient);\n$gradient-border: var(--gradient-border);\n\n//text-colors\n$text-color-W: var(--text-color-W);\n\n//border\n$border: var(--border);\n\n//scrollbar\n$scrollbar-background: var(--scrollbar-background);\n$scrollbar-hover-color: var(--scrollbar-hover-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_box_radio": `style_container_box_radio__GbZ0C`,
	"pagination": `style_pagination__-pnY-`,
	"interface_heading_row": `style_interface_heading_row__YDt67`,
	"interface_noResults": `style_interface_noResults__uF3o0`,
	"container": `style_container__hMoe8`,
	"container_box_details": `style_container_box_details__SyGIC`,
	"interface": `style_interface__sV+t1`,
	"link": `style_link__ZP4xt`,
	"text-gradient-intel": `style_text-gradient-intel__Idx4A`,
	"text-xs": `style_text-xs__9A5MU`,
	"text-sm": `style_text-sm__bQ45a`,
	"interface_heading": `style_interface_heading__-6UwV`,
	"interface_footer": `style_interface_footer__auf2x`,
	"text-base": `style_text-base__HAZGJ`,
	"text-lg": `style_text-lg__5aj0W`,
	"text-xl": `style_text-xl__ipTg8`,
	"text-leading": `style_text-leading__-OIIh`,
	"breadcumb": `style_breadcumb__QNpKd`,
	"divider": `style_divider__P-E1L`,
	"badge": `style_badge__yYZwh`,
	"xs": `style_xs__DkoRS`,
	"sm": `style_sm__B8cj4`,
	"primary": `style_primary__YImac`,
	"pm": `style_pm__er+wE`,
	"sd": `style_sd__QHKka`,
	"Likely": `style_Likely__g7JW0`,
	"Unvalidated": `style_Unvalidated__nwQtF`,
	"Verified": `style_Verified__YsV-R`,
	"green": `style_green__+An0w`,
	"off": `style_off__swAqn`,
	"badgeTable": `style_badgeTable__aWDsd`,
	"table": `style_table__Qfdlv`,
	"style-1": `style_style-1__Fy5p5`,
	"label": `style_label__tcCt-`,
	"noBorder": `style_noBorder__DVv17`,
	"disabled": `style_disabled__xdb2v`,
	"active": `style_active__Z4743`,
	"info": `style_info__2waEW`,
	"interface_foot": `style_interface_foot__feYli`,
	"container_active": `style_container_active__J1jPn`,
	"container_box": `style_container_box__-AkNw`,
	"container_box_details_last4": `style_container_box_details_last4__UYXoY`,
	"container_box_details_exp": `style_container_box_details_exp__-6yU+`,
	"container_box_details_default": `style_container_box_details_default__I54ND`
};
export default ___CSS_LOADER_EXPORT___;
